// import ImagesIconsMain from './Images/icons/main.svg'
// import ImagesIconsMainNoframe from './Images/icons/main-noframe.svg'
// import ImagesIcons512 from './Images/icons/512.png'
// import ImagesIcons384 from './Images/icons/384.png'
// import ImagesIcons256 from './Images/icons/256.png'
// import ImagesIcons192 from './Images/icons/192.png'
// import ImagesIcons144 from './Images/icons/144.png'
// import ImagesIcons96 from './Images/icons/96.png'
// import ImagesIcons48 from './Images/icons/48.png'
import ImagesUser from './Images/user.svg';
import ImagesLogo from './Images/logo.png';
import ImagesLoader from './Images/loader.svg';
import ImagesLoaderBlack from './Images/loader-black.svg';
import ImagesSearch from './Images/search.svg';
import ImagesMediaBack from './Images/media-back.svg';
import ImagesLogoBloodBank from './Images/logo-bloodbank.svg';
import ImagesLogoSelf from './Images/logo-self.svg';
import ImagesMReport from './Images/mreport.svg';
import ImagesMSettings from './Images/msettings.svg';
import ImagesInsertBarcode from './Images/insert-barcode.svg';
import ImagesUpdateBarcode from './Images/update-barcode.svg';
import ImagesClearBarcode from './Images/clear-barcode.svg';
import ImagesCellTypeBarcode from './Images/cell-type-barcode.svg';
import ImagesRadar from './Images/radar.svg';
import ImageTestTube from './Images/test-tube.svg';
import ImagesTestTubeWhite from './Images/test-tube-white.svg';
import ImagesPackAlarm2 from './Images/pack/alarm2.svg';
import ImagesPackAlignRight from './Images/pack/align-right.svg';
import ImagesPackCalendar from './Images/pack/calendar.svg';
import ImagesPackCancel from './Images/pack/cancel.svg';
import ImagesPackCancelWhite from './Images/pack/cancel-white.svg';
import ImagesPackCheck from './Images/pack/check.svg';
import ImagesPackCheckWhite from './Images/pack/check-white.svg';
import ImagesPackClicker from './Images/pack/clicker.svg';
import ImagesPackClickerWhite from './Images/pack/clicker-white.svg';
import ImagesPackCloud from './Images/pack/cloud.svg';
import ImagesPackDiagram from './Images/pack/diagram.svg';
import ImagesPackDiagramGreen from './Images/pack/diagram-green.svg';
import ImagesPackDownload1 from './Images/pack/download1.svg';
import ImagesPackDownload1White from './Images/pack/download1-white.svg';
import ImagesPackEdit1 from './Images/pack/edit1.svg';
import ImagesPackEdit1White from './Images/pack/edit1-white.svg';
import ImagesPackExpand from './Images/pack/expand.svg';
import ImagesPackEye from './Images/pack/eye.svg';
import ImagesPackEyeWhite from './Images/pack/eye-white.svg';
import ImagesPackFile from './Images/pack/file.svg';
import ImagesPackFileGreen from './Images/pack/file-green.svg';
import ImagesPackFileWhite from './Images/pack/file-white.svg';
import ImagesPackHeadphones from './Images/pack/headphones.svg';
import ImagesPackHighlighter from './Images/pack/highlighter.svg';
import ImagesPackHighlighterWhite from './Images/pack/highlighter-white.svg';
import ImagesPackIdea from './Images/pack/idea.svg';
import ImagesPackLeftArrow1 from './Images/pack/left-arrow1.svg';
import ImagesPackLeftArrow1White from './Images/pack/left-arrow1-white.svg';
import ImagesPackMenu1 from './Images/pack/menu1.svg';
import ImagesPackMenu2 from './Images/pack/menu2.svg';
import ImagesPackMenu2White from './Images/pack/menu2-white.svg';
import ImagesPackMenu3 from './Images/pack/menu3.svg';
import ImagesPackMinimize from './Images/pack/minimize.svg';
import ImagesPackMinus from './Images/pack/minus.svg';
import ImagesPackMinusWhite from './Images/pack/minus-white.svg';
import ImagesPackOpenLock from './Images/pack/open-lock.svg';
import ImagesPackOpenLockWhite from './Images/pack/open-lock-white.svg';
import ImagesPackPadlock from './Images/pack/padlock.svg';
import ImagesPackPadlockWhite from './Images/pack/padlock-white.svg';
import ImagesPackPlus from './Images/pack/plus.svg';
import ImagesPackPlusWhite from './Images/pack/plus-white.svg';
import ImagesPackPrinter from './Images/pack/printer.svg';
import ImagesPackQrCode from './Images/pack/qr-code.svg';
import ImagesPackReply from './Images/pack/reply.svg';
import ImagesPackReplyWhite from './Images/pack/reply-white.svg';
import ImagesPackTarget from './Images/pack/target.svg';
import ImagesPackTargetWhite from './Images/pack/target-white.svg';
import ImagesPackTrash1White from './Images/pack/trash1-white.svg';
import ImagesPackTrash1Red from './Images/pack/trash1-red.svg';
import ImagesPackTrash1 from './Images/pack/trash1.svg';
import ImagesPackUpArrow1 from './Images/pack/up-arrow1.svg';
import ImagesPackUpArrow1White from './Images/pack/up-arrow1-white.svg';
import ImagesPackUpload1 from './Images/pack/upload1.svg';
import ImagesPackUpload1White from './Images/pack/upload1-white.svg';
import bgMasthead from './Images/landing/bg-masthead.jpg';
import bgShowcase1 from './Images/landing/bg-showcase-1.jpg';
import bgShowcase2 from './Images/landing/bg-showcase-2.jpg';
import bgShowcase3 from './Images/landing/bg-showcase-3.jpg';
import testimonials1 from './Images/landing/testimonials-1.jpg';
import testimonials2 from './Images/landing/testimonials-2.jpg';
import testimonials3 from './Images/landing/testimonials-3.jpg';

import VideosSample from './Videos/sample.mp4';

import AudioNotification1 from './Audios/notification1.mp3';
import AudioNotification2 from './Audios/notification2.mp3';

class Resource {
    static AUDIO = {
        NOTIFICATION1: AudioNotification1,
        NOTIFICATION2: AudioNotification2
    };

    static EXE = {
        PRINTER: `${window.ENV.MAIN_SERVER}/Apps/AftabWebClientUtility.zip`
    };

    static HASH = {
        AWAITING_HOSPITAL_NORM_EMER_REQUESTS: '#awaintingHospitalNormEmerRequests',
        AWAITING_HOSPITAL_NORM_REQUESTS: '#awaintingHospitalNormRequests',
        AWAITING_HOSPITAL_EMER_REQUESTS: '#awaintingHospitalEmerRequests',
        AWAITING_HOSPITAL_ORG_EMER_REQUESTS: '#awaintingHospitalOrgEmerRequests',
        AWAITING_HOSPITAL_WASH_REQUESTS: '#awaintingHospitalWashRequests',
        AWAITING_HOSPITAL_IRRADIATE_REQUESTS: '#awaintingHospitalIrradiateRequests',
        AWAITING_ORG_NORM_REQUESTS: '#awaintingOrgNormRequests',
        AWAITING_ORG_EMER_REQUESTS: '#awaintingOrgEmerRequests',
        AWAITING_ORG_WASH_REQUESTS: '#awaintingOrgWashRequests',
        AWAITING_ORG_IRRADIATE_REQUESTS: '#awaintingOrgIrradiateRequests'
    };

    static IMAGE = {
        RANDOM: _ => `https://picsum.photos/id/${Math.ceil(Math.random() * 1080) + 1}/300`,
        ICON: {
            // MAIN: ImagesIconsMain,
            // MAIN_NOFRAME: ImagesIconsMainNoframe,
            // 512: ImagesIcons512,
            // 384: ImagesIcons384,
            // 256: ImagesIcons256,
            // 192: ImagesIcons192,
            // 144: ImagesIcons144,
            // 96: ImagesIcons96,
            // 48: ImagesIcons48
        },
        PACK: {
            //     ACTION_CAMERA: ImagesPackActionCamera,
            //     ADD_USER: ImagesPackAddUser,
            //     ADD: ImagesPackAdd,
            //     ALARM1: ImagesPackAlarm1,
            ALARM2: ImagesPackAlarm2,
            //     ALIGN_LEFT: ImagesPackAlignLeft,
            ALIGN_RIGHT: ImagesPackAlignRight,
            //     ALIGNMENT: ImagesPackAlignment,
            //     APERTURE: ImagesPackAperture,
            //     BAR_CHART: ImagesPackBarChart,
            //     BATTERY_LEVEL: ImagesPackBatteryLevel,
            //     BINOCULARS: ImagesPackBinoculars,
            //     BLUETOOTH: ImagesPackBluetooth,
            //     BOOKMARK: {
            //         STROKE: ImagesPackBookmark1,
            //         FILL: ImagesPackBookmark2
            //     },
            //     BRIEFCASE: ImagesPackBriefcase,
            //     BROKEN_LINK: ImagesPackBrokenLink,
            //     CALCULATOR: ImagesPackCalculator,
            CALENDAR: ImagesPackCalendar,
            //     CAMERA_TIMER: ImagesPackCameraTimer,
            //     CAMERA: ImagesPackCamera,
            CANCEL: {
                BLACK: ImagesPackCancel,
                WHITE: ImagesPackCancelWhite
            },
            //     CHANGE: ImagesPackChange,
            //     CHAT: ImagesPackChat,
            CHECK: {
                BLACK: ImagesPackCheck,
                WHITE: ImagesPackCheckWhite
            },
            //     CHEVRON: {
            //         BLACK: ImagesPackChevron,
            //         WHITE: ImagesPackChevronWhite,
            //         VIOLET: ImagesPackChevronViolet
            //     },
            //     CHROME: ImagesPackChrome,
            CLICKER: {
                BLACK: ImagesPackClicker,
                WHITE: ImagesPackClickerWhite
            },
            //     CLIP: ImagesPackClip,
            //     CLOUD_COMPUTING1: ImagesPackCloudComputing1,
            //     CLOUD_COMPUTING2: ImagesPackCloudComputing2,
            CLOUD: ImagesPackCloud,
            //     COMPASS: ImagesPackCompass,
            //     COMPUTER: ImagesPackComputer,
            //     COPY: ImagesPackCopy,
            //     CREDIT_CARD: ImagesPackCreditCard,
            //     CROP: ImagesPackCrop,
            //     CUBE: ImagesPackCube,
            //     CURSOR: ImagesPackCursor,
            //     CUT1: ImagesPackCut1,
            //     CUT2: ImagesPackCut2,
            //     DASHBOARD: ImagesPackDashboard,
            //     DAY1: ImagesPackDay1,
            //     DAY2: ImagesPackDay2,
            //     DAY3: ImagesPackDay3,
            //     DELETE: ImagesPackDelete,
            DIAGRAM: {
                BLACK: ImagesPackDiagram,
                GREEN: ImagesPackDiagramGreen
            },
            //     DIAMOND: ImagesPackDiamond,
            //     DISABLED: ImagesPackDisabled,
            //     DISKETTE: ImagesPackDiskette,
            //     DISLIKE: ImagesPackDislike,
            //     DOWN_ARROW1: ImagesPackDownArrow1,
            //     DOWN_ARROW2: ImagesPackDownArrow2,
            //     DOWN_ARROW3: ImagesPackDownArrow3,
            DOWNLOAD1: {
                WHITE: ImagesPackDownload1White,
                BLACK: ImagesPackDownload1
            },
            //     DOWNLOAD2: ImagesPackDownload2,
            //     DSLR_CAMERA: ImagesPackDslrCamera,
            //     EARTH_GRID: ImagesPackEarthGrid,
            EDIT1: {
                BLACK: ImagesPackEdit1,
                WHITE: ImagesPackEdit1White
            },
            //     EDIT2: ImagesPackEdit2,
            //     EMAIL1: ImagesPackEmail1,
            //     EMAIL2: ImagesPackEmail2,
            //     EMAIL3: ImagesPackEmail3,
            //     EMPTY_BATTERY: ImagesPackEmptyBattery,
            //     EQUALIZER: ImagesPackEqualizer,
            //     ERASER: ImagesPackEraser,
            EXPAND: ImagesPackExpand,
            EYE: {
                BLACK: ImagesPackEye,
                WHITE: ImagesPackEyeWhite
            },
            //     FACEBOOK: ImagesPackFacebook,
            //     FAST_FORWARD: ImagesPackFastForward,
            //     FAVOURITE: ImagesPackFavourite,
            FILE: {
                BLACK: ImagesPackFile,
                GREEN: ImagesPackFileGreen,
                WHITE: ImagesPackFileWhite
            },
            //     FILTER: ImagesPackFilter,
            //     FIREFOX: ImagesPackFirefox,
            //     FLAG: ImagesPackFlag,
            //     FLASH_OFF: ImagesPackFlashOff,
            //     FOCUS1: ImagesPackFocus1,
            //     FOCUS2: ImagesPackFocus2,
            //     FOLDER: ImagesPackFolder,
            //     FOLLOWERS: ImagesPackFollowers,
            //     HD: ImagesPackHd,
            HEADPHONES: ImagesPackHeadphones,
            //     HEART: ImagesPackHeart,
            //     HIDE: ImagesPackHide,
            HIGHLIGHTER: {
                BLACK: ImagesPackHighlighter,
                WHITE: ImagesPackHighlighterWhite
            },
            //     HOME: ImagesPackHome,
            //     HOURGLASS: ImagesPackHourglass,
            IDEA: ImagesPackIdea,
            //     INCREASE: ImagesPackIncrease,
            //     INFORMATION: ImagesPackInformation,
            //     INSTAGRAM: ImagesPackInstagram,
            //     ISO: ImagesPackIso,
            //     JOKE: ImagesPackJoke,
            //     JUSTIFY: ImagesPackJustify,
            //     KEY: ImagesPackKey,
            //     LAMP: ImagesPackLamp,
            //     LAYOUT: ImagesPackLayout,
            //     LEAF: ImagesPackLeaf,
            LEFT_ARROW1: {
                BLACK: ImagesPackLeftArrow1,
                WHITE: ImagesPackLeftArrow1White
            },
            //     LEFT_ARROW2: ImagesPackLeftArrow2,
            //     LEFT_ARROW3: {
            //         BLACK: ImagesPackLeftArrow3,
            //         WHITE: ImagesPackLeftArrow3White
            //     },
            //     LEVELS: ImagesPackLevels,
            //     LIGHTS: ImagesPackLights,
            //     LIKE: ImagesPackLike,
            //     LINK: ImagesPackLink,
            //     LOADING: ImagesPackLoading,
            //     LOG_IN: ImagesPackLogIn,
            //     LOG_OUT: ImagesPackLogOut,
            //     MEDAL: ImagesPackMedal,
            //     MEGAPHONE: ImagesPackMegaphone,
            MENU1: ImagesPackMenu1,
            MENU2: {
                BLACK: ImagesPackMenu2,
                WHITE: ImagesPackMenu2White
            },
            MENU3: ImagesPackMenu3,
            //     MENU4: {
            //         BLACK: ImagesPackMenu4,
            //         WHITE: ImagesPackMenu4White
            //     },
            //     MICROPHONE: ImagesPackMicrophone,
            MINIMIZE: ImagesPackMinimize,
            MINUS: {
                BLACK: ImagesPackMinus,
                WHITE: ImagesPackMinusWhite
            },
            //     MONEY: ImagesPackMoney,
            //     MONITOR: ImagesPackMonitor,
            //     MOON: ImagesPackMoon,
            //     MORE1: {
            //         FILL: ImagesPackMore1,
            //         STROKE: ImagesPackMore2
            //     },
            //     MORE2: {
            //         FILL: ImagesPackMore3,
            //         STROKE: ImagesPackMore4
            //     },
            //     MORE3: ImagesPackMore5,
            //     MOVE: ImagesPackMove,
            //     MUSIC: ImagesPackMusic,
            //     MUTE1: ImagesPackMute1,
            //     MUTE2: ImagesPackMute2,
            //     NIGHT_LANDSCAPE: ImagesPackNightLandscape,
            //     NIGHT_MODE: ImagesPackNightMode,
            //     NIGHT: ImagesPackNight,
            //     NO_PHOTO: ImagesPackNoPhoto,
            //     OLD_CAMERA: ImagesPackOldCamera,
            OPEN_LOCK: {
                BLACK: ImagesPackOpenLock,
                WHITE: ImagesPackOpenLockWhite
            },
            PADLOCK: {
                BLACK: ImagesPackPadlock,
                WHITE: ImagesPackPadlockWhite
            },
            //     PAINT_BUCKET: ImagesPackPaintBucket,
            //     PASTE: ImagesPackPaste,
            //     PAUSE: ImagesPackPause,
            //     PENCIL: ImagesPackPencil,
            //     PHONE_CALL1: ImagesPackPhoneCall1,
            //     PHONE_CALL2: ImagesPackPhoneCall2,
            //     PHONE_CALL3: ImagesPackPhoneCall3,
            //     PHOTO_CAMERA: ImagesPackPhotoCamera,
            //     PHOTO_GALLERY: ImagesPackPhotoGallery,
            //     PICTURE: ImagesPackPicture,
            //     PIE_CHART: ImagesPackPieChart,
            //     PIGGY_BANK: ImagesPackPiggyBank,
            //     PIN1: ImagesPackPin1,
            //     PIN2: ImagesPackPin2,
            //     PLAY: ImagesPackPlay,
            PLUS: {
                BLACK: ImagesPackPlus,
                WHITE: ImagesPackPlusWhite
            },
            //     POWER_BUTTON: ImagesPackPowerButton,
            PRINTER: ImagesPackPrinter,
            //     PUSH_PIN: ImagesPackPushPin,
            //     PUZZLE: ImagesPackPuzzle,
            QR_CODE: ImagesPackQrCode,
            //     QUESTION: ImagesPackQuestion,
            //     READY: ImagesPackReady,
            //     RED_EYES: ImagesPackRedEyes,
            //     REDUCE: ImagesPackReduce,
            //     REFRESH: ImagesPackRefresh,
            //     REMOVE_USER: ImagesPackRemoveUser,
            //     REPLY_ALL: ImagesPackReplyAll,
            REPLY: {
                BLACK: ImagesPackReply,
                WHITE: ImagesPackReplyWhite
            },
            //     REWIND: ImagesPackRewind,
            //     RIGHT_ARROW1: ImagesPackRightArrow1,
            //     RIGHT_ARROW2: {
            //         BLACK: ImagesPackRightArrow2,
            //         WHITE: ImagesPackRightArrow2White
            //     },
            //     RING_LIGHT: ImagesPackRingLight,
            //     ROTATE: ImagesPackRotate,
            //     SAD: ImagesPackSad,
            //     SAFARI: ImagesPackSafari,
            //     SCALE: ImagesPackScale,
            //     SCREENSHOT: ImagesPackScreenshot,
            //     SETTINGS: ImagesPackSettings,
            //     SHARE: ImagesPackShare,
            //     SHIELD: ImagesPackShield,
            //     SHOPPING_CART: ImagesPackShoppingCart,
            //     SHUFFLE: ImagesPackShuffle,
            //     SILENCE: ImagesPackSilence,
            //     SMARTPHONE1: ImagesPackSmartphone1,
            //     SMARTPHONE2: ImagesPackSmartphone2,
            //     SMILE1: ImagesPackSmile1,
            //     SMILE2: ImagesPackSmile2,
            //     SNOWFLAKE: ImagesPackSnowflake,
            //     SOFT_BOX: ImagesPackSoftBox,
            //     STAR: ImagesPackStar,
            //     STOP: ImagesPackStop,
            //     STRAIGHT: ImagesPackStraight,
            //     SUN: ImagesPackSun,
            //     SURPRISE: ImagesPackSurprise,
            //     SWITCH_CAMERA: ImagesPackSwitchCamera,
            //     SWITCH1: ImagesPackSwitch1,
            //     SWITCH2: ImagesPackSwitch2,
            //     TAG: ImagesPackTag,
            TARGET: {
                BLACK: ImagesPackTarget,
                WHITE: ImagesPackTargetWhite
            },
            //     THERMOMETER: ImagesPackThermometer,
            //     THUNDERBOLT: ImagesPackThunderbolt,
            //     TIMER1: ImagesPackTimer1,
            //     TIMER2: ImagesPackTimer2,
            //     TOOLS: ImagesPackTools,
            TRASH1: {
                BLACK: ImagesPackTrash1,
                RED: ImagesPackTrash1Red,
                WHITE: ImagesPackTrash1White
            },
            //     TRASH2: {
            //         BLACK: ImagesPackTrash2,
            //         RED: ImagesPackTrash2Red,
            //         WHITE: ImagesPackTrash2White
            //     },
            //     TWITTER: ImagesPackTwitter,
            //     UMBRELLA1: ImagesPackUmbrella1,
            //     UMBRELLA2: ImagesPackUmbrella2,
            UP_ARROW1: {
                BLACK: ImagesPackUpArrow1,
                WHITE: ImagesPackUpArrow1White
            },
            //     UP_ARROW2: ImagesPackUpArrow2,
            //     UP_ARROW3: ImagesPackUpArrow3,
            UPLOAD1: {
                BLACK: ImagesPackUpload1,
                WHITE: ImagesPackUpload1White
            },
            //     UPLOAD2: ImagesPackUpload2,
            //     USB: ImagesPackUsb,
            //     USER1: ImagesPackUser1,
            //     USER2: ImagesPackUser2,
            //     VIDEO_CAMERA: ImagesPackVideoCamera,
            //     VIDEO: ImagesPackVideo,
            //     VOLUME: ImagesPackVolume,
            //     WALL_CLOCK: ImagesPackWallClock,
            //     WIFI: ImagesPackWifi,
            //     WIND: ImagesPackWind,
            //     YOUTUBE: ImagesPackYoutube
        },
        LANDING: {
            BG_MASTHEAD: bgMasthead,
            BG_SHOWCASE_1: bgShowcase1,
            BG_SHOWCASE_2: bgShowcase2,
            BG_SHOWCASE_3: bgShowcase3,
            TESTIMONIALS_1: testimonials1,
            TESTIMONIALS_2: testimonials2,
            TESTIMONIALS_3: testimonials3,
        },
        USER: ImagesUser,
        LOGO: ImagesLogo,
        LOADER: ImagesLoader,
        LOADER_BLACK: ImagesLoaderBlack,
        SEARCH: ImagesSearch,
        MEDIA_BACK: ImagesMediaBack,
        LOGO_BLOOD_BANK: ImagesLogoBloodBank,
        LOGO_SELF: ImagesLogoSelf,
        // PIE_CHART_BACKGROUND: ImagesPieChartBackground,
        // BAR_CHART_BACKGROUND: ImagesBarChartBackground,
        // M_CHART: ImagesMChart,
        M_REPORT: ImagesMReport,
        // M_EMAIL: ImagesMEmail,
        // M_OPTIONS: ImagesMOptions,
        M_SETTINGS: ImagesMSettings,
        // M_BLOOD: ImagesMBlood,
        INSERT_BARCODE: ImagesInsertBarcode,
        UPDATE_BARCODE: ImagesUpdateBarcode,
        CLEAR_BARCODE: ImagesClearBarcode,
        CELL_TYPE_BARCODE: ImagesCellTypeBarcode,
        RADAR: ImagesRadar,
        TEST_TUBE: {
            BLACK:ImageTestTube,
            WHITE:ImagesTestTubeWhite
        },
    };

    static ROUTE = {
        LOGIN: '/login',
        LOGOUT: '/logout',
        HOME: '/',
        LANDING: '/landing',
        DASHBOARD: '/management/dashboard',
        ORG: {
            INCOMING: '/org/incoming',
            OUTGOING: '/org/outgoing',
            NORM_REQUESTS: '/org/requests/norm',
            EMER_REQUESTS: '/org/requests/emer',
            WASH_REQUESTS: '/org/requests/wash',
            IRRADIATE_REQUESTS: '/org/requests/irradiate',
            COMPLICATION: '/org/complication'
        },
        HOSPITAL: {
            INCOMING: '/hospital/incoming',
            OUTGOING: '/hospital/outgoing',
            READY: '/hospital/ready',
            RESERVED: '/hospital/reserved',
            RESERVE_LOG: '/hospital/reserve_log',
            DESTROYED: '/hospital/destroyed',
            RETURNED_TO_HOSPITAL: '/hospital/returned/hos',
            RETURNED_TO_ORG: '/hospital/returned/org',
            NORM_REQUESTS: '/hospital/requests/norm',
            ORG_NORM_REQUESTS: '/hospital/requests/org_norm',
            EMER_REQUESTS: '/hospital/requests/emer',
            ORG_EMER_REQUESTS: '/hospital/requests/org_emer',
            WASH_REQUESTS: '/hospital/requests/wash',
            IRRADIATE_REQUESTS: '/hospital/requests/irradiate',
        },
        SECTION: {
            NORM_REQUESTS: '/section/requests/norm',
            EMER_REQUESTS: '/section/requests/emer',
            ORG_EMER_REQUESTS: '/section/requests/org_emer',
            WASH_REQUESTS: '/section/requests/wash',
            IRRADIATE_REQUESTS: '/section/requests/irradiate',
            COMPLICATION: '/section/complication',
        },
        TRACK_PRODUCT: '/hospital/track',
        PATIENT: '/patient',
        CONFIGURATION: {
            ROLES: '/config/roles',
            HOSPITAL_POLICIES: '/config/policies',
            HOSPITALS: '/config/hospitals',
            SECTIONS: '/config/sections',
            DOCTORS: '/config/doctors',
            USERS: '/config/users',
        },
        SETTINGS: '/setting',
        UPDATE_HISTORY: '/update/history'
    };

    static STRING = {
        FETCH: {
            SERVER_ERROR: 'خطا ارتباط با سرور، لطفا دوباره امتحان کنید !',
            SUBMIT_SUCCESSFUL: 'با موفقیت ثبت شد.',
            GET_SUCCESSFUL: 'با موفقیت دریافت شد.',
            INSERT_SUCCESSFUL: 'با موفقیت اضافه شد.',
            UPDATE_SUCCESSFUL: 'با موفقیت ویرایش شد.',
            DELETE_SUCCESSFUL: 'با موفقیت حذف شد.',
            SEND_SUCCESSFUL: 'با موفقیت ارسال شد.',
            SUBMIT_FAILED: 'ثبت با خطا روبرو شد.',
            GET_FAILED: 'دریافت اطلاعات با خطا روبرو شد.',
            INSERT_FAILED: 'افزودن با خطا روبرو شد.',
            UPDATE_FAILED   : 'ویرایش با خطا روبرو شد.',
            DELETE_FAILED: 'حذف با خطا روبرو شد.'
        }
    };

    static VERSION = '2.1.0';

    static VIDEO = {
        SAMPLE: VideosSample
    };
}

export default Resource;